<template>
  <div>
    <b-card v-if="working" class="text-center">
      <div v-if="job_status && job_status.id">{{ job_status.description }}</div>
      <i class="fa fa-spinner fa-spin fa-4x"></i>
    </b-card>
    <div v-if="!working">
      <b-card no-body>
        <b-tabs card>
          <b-tab title="Lista">
            <div class="text-right mb-3">
              <router-link
                class="btn btn-primary"
                :to="{ name: 'users.create' }"
                ><i class="fa fa-plus"></i> Criar</router-link
              >
            </div>
            <Grid
              name="usersGrid"
              v-bind:url="url"
              v-bind:columns="columns"
              :pageable="true"
              :filterable="true"
              :sortable="true"
              v-bind:schemaModelFields="schemaModelFields"
            ></Grid>
          </b-tab>
          <b-tab title="Operações">
            <b-button class="btn btn-primary" @click="showModal()"
              >Criar utilizadores para famílias</b-button
            >
            <b-button class="btn btn-primary" @click="showEmailsModal()"
              >Enviar emails</b-button
            >
            <b-table striped :fields="jobs_fields" :items="jobs_list">
              <template v-slot:cell(state)="data">
                {{ states.translate(data.value, "jobs") }}
              </template>
              <template #cell(show_details)="row">
                <b-button size="sm" @click="row.toggleDetails" class="mr-2">
                  {{ row.detailsShowing ? "Hide" : "Show" }} Details
                </b-button>
              </template>
              <template #cell(count_emails)="row">
                {{ row.item.emails.data.length }}
              </template>

              <template #row-details="row">
                <operation :items="row.item.emails.data"></operation>
              </template>
            </b-table>
          </b-tab>
        </b-tabs>
      </b-card>
      <b-modal id="send-emails" hide-footer>
        <template v-slot:modal-title>
          Enviar emails de novo utilizador
        </template>
        <b-button class="mt-3" @click="$bvModal.hide('send-emails')"
          >Cancelar</b-button
        >
        <b-button
          variant="success"
          class="mt-3 pull-right"
          @click="sendEmails()"
          >Enviar</b-button
        >
      </b-modal>
      <b-modal id="create-users" hide-footer>
        <template v-slot:modal-title> Criar Utilizadores </template>
        <div class="d-block">
          <p>
            Serão criados os utilizadores para as famílias que ainda não têm
          </p>
        </div>
        <b-button class="mt-3" @click="$bvModal.hide('create-users')"
          >Cancelar</b-button
        >
        <b-button
          variant="success"
          class="mt-3 pull-right"
          @click="createUsers()"
          >Continuar</b-button
        >
      </b-modal>
    </div>
  </div>
</template>

<script>
import Grid from "@/components/Grid.vue";
import router from "@/router";
import States from "@/components/Lists.js";
import Operation from "../fees/operations.vue";

export default {
  name: "UsersGrid",
  components: {
    Grid,
    Operation,
  },
  data() {
    return {
      working: false,
      schemaModelFields: {
        created_at: {
          type: "date",
        },
      },
      states: States,
      jobs_list: [],
      url: "users",
      columns: [
        {
          template: this.getBtnTemplate,
          title: "",
          width: "180px",
        },
        {
          field: "id",
          title: "Id",
          width: "120px",
        },
        {
          field: "name",
          title: "Nome",
        },
        {
          field: "email",
          title: "Email",
        },
        {
          field: "created_at",
          title: "Criado em",
          format: "{0:dd/MM/yyyy HH:mm}",
          type: "date",
          width: "180px",
          filterable: {
            // ui: "datetimepicker"
            ui: function (element) {
              element.kendoDateTimePicker({
                format: "dd/MM/yyyy HH:mm",
              });
            },
          },
        },
      ],
      jobs_fields: [
        {
          key: "description",
          text: "Descrição",
        },
        {
          key: "state",
          text: "Estado",
        },
        {
          key: "count_emails",
          text: "Emails",
        },
        {
          key: "updated_at",
          value: "Última atualização",
        },
        {
          key: "show_details",
          text: "",
        },
      ],
    };
  },
  methods: {
    getBtnTemplate: function (item) {
      var route = router.resolve({
        name: "users.edit",
        params: {
          id: item.id,
        },
      });
      if (this.$auth.check("roles.edit")) {
        return (
          '<a href="' +
          route.href +
          '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
        );
      }
      return "";
    },
    sendEmails() {
      let data = {};
      this.$bvModal.hide("send-emails");
      this.working = true;
      this.axios.post("users/send_welcome_emails", data).then((response) => {
        this.working = false;
        this.getJobs();
      });
    },
    createUsers() {
      let data = {};
      this.$bvModal.hide("create-users");
      this.working = true;
      this.axios.post("users/create_family_users", data).then((response) => {
        this.working = false;
        this.getJobs();
      });
    },
    showModal() {
      this.$bvModal.show("create-users");
    },
    showEmailsModal() {
      this.$bvModal.show("send-emails");
    },
    getJobs() {
      this.axios.get("jobs/all/users").then((response) => {
        this.jobs_list = response.data.data;
      });
    },
    checkProgress(job_id) {
      let job = job_id || null;
      let job_url = "jobs/status/users";
      if (job) {
        job_url += "/" + job;
      }
      var that = this;
      this.axios.get(job_url).then((response) => {
        this.job_status = response.data.data;
        if (this.job_status == null) {
          return;
        }
        if (this.job_status.state == 0 || this.job_status.state == 1) {
          that.working = true;
          setTimeout(function () {
            that.checkProgress(that.job_status.id);
          }, 3 * 1000);
        } else {
          that.working = false;
          that.getJobs();
        }
      });
    },
  },
  created() {
    this.checkProgress();
    this.getJobs();
  },
};
</script>
